import { render, staticRenderFns } from "./AssignmentReview.vue?vue&type=template&id=247719c6&scoped=true&"
import script from "./AssignmentReview.vue?vue&type=script&lang=js&"
export * from "./AssignmentReview.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentReview.vue?vue&type=style&index=0&id=247719c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247719c6",
  null
  
)

export default component.exports